import { useEffect } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogUrl?: string;
  twitterTitle?: string;
  twitterDescription?: string;
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title = 'Pop The Balloon - Find Your Perfect Match | Revolutionary Dating App',
  description = 'Experience dating like never before! Inspired by the hit show, our app brings authentic connections through real reactions. No endless swiping - just genuine chemistry. Download now on iOS & Android.',
  canonical,
  ogTitle,
  ogDescription,
  ogUrl,
  twitterTitle,
  twitterDescription,
}) => {
  useEffect(() => {
    // Update page title
    document.title = title;

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }

    // Update canonical URL if provided
    if (canonical) {
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (canonicalLink) {
        canonicalLink.setAttribute('href', canonical);
      } else {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        canonicalLink.setAttribute('href', canonical);
        document.head.appendChild(canonicalLink);
      }
    }

    // Update Open Graph tags
    const ogTitleMeta = document.querySelector('meta[property="og:title"]');
    if (ogTitleMeta) {
      ogTitleMeta.setAttribute('content', ogTitle || title);
    }

    const ogDescMeta = document.querySelector('meta[property="og:description"]');
    if (ogDescMeta) {
      ogDescMeta.setAttribute('content', ogDescription || description);
    }

    const ogUrlMeta = document.querySelector('meta[property="og:url"]');
    if (ogUrlMeta && ogUrl) {
      ogUrlMeta.setAttribute('content', ogUrl);
    }

    // Update Twitter tags
    const twitterTitleMeta = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitleMeta) {
      twitterTitleMeta.setAttribute('content', twitterTitle || title);
    }

    const twitterDescMeta = document.querySelector('meta[property="twitter:description"]');
    if (twitterDescMeta) {
      twitterDescMeta.setAttribute('content', twitterDescription || description);
    }

    const twitterUrlMeta = document.querySelector('meta[property="twitter:url"]');
    if (twitterUrlMeta && ogUrl) {
      twitterUrlMeta.setAttribute('content', ogUrl);
    }
  }, [title, description, canonical, ogTitle, ogDescription, ogUrl, twitterTitle, twitterDescription]);

  return null;
};

export default SEOHead;